// @ts-ignore
import { ReactComponent as LoaderSVG } from "~/assets/svg/loader.svg";
import * as S from "./styles";

type Props = { fullWidth?: boolean; height?: string; width?: string };

const Loader = ({ fullWidth }: Props) => {
  return (
    <S.LoaderContainer fullWidth={fullWidth}>
      <LoaderSVG />
    </S.LoaderContainer>
  );
};

export function Loading({ height, width }: Props) {
  return (
    <S.LoaderContainerNotFixed height={height} width={width}>
      <LoaderSVG />
    </S.LoaderContainerNotFixed>
  );
}

export default Loader;
